import { useAppSelector } from '@/store/store';
import { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function AuthGuard({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const shouldRedirectToDash = isAuthenticated && pathname !== '/dashboard';
  const shouldRedirectToLogin = !isAuthenticated && pathname !== '/login';
  useEffect(() => {
    if (shouldRedirectToDash) {
      navigate('/dashboard');
    } else if (shouldRedirectToLogin) {
      navigate('/login');
    }
  }, [shouldRedirectToDash, shouldRedirectToLogin]);

  return shouldRedirectToDash || shouldRedirectToLogin ? null : children;
}
